//--------------- IMPORTAÇÕES ---------------//
import { X } from "lucide-react";
import { LeadsContext } from "../../context/LeadsContext";
import { loadLeadsService, loadTagsService, removeTagsBulkService } from "../../services";
import { useContext, useEffect } from "react";



//--------------- EXPORTAÇÃO DO MODAL REMOVE TAGS BULK ---------------//
export default function ModalRemoveTagsBulk() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { isOpenModalRemoveTagsBulk, setIsOpenModalRemoveTagsBulk } = useContext(LeadsContext);
  const { tagsAvailable, setTagsAvailable } = useContext(LeadsContext);
  const { tagSearched, setTagSearched } = useContext(LeadsContext);
  const { tagsSelected, setTagsSelected } = useContext(LeadsContext);
  const { leads, setLeads } = useContext(LeadsContext);
  const { itemsPerPage, setItemsPerPage } = useContext(LeadsContext);
  const { currentPage, setCurrentPage } = useContext(LeadsContext);
  const { statusFilter, setStatusFilter } = useContext(LeadsContext);
  const { tagFilter, setTagFilter } = useContext(LeadsContext);
  const { total, setTotal } = useContext(LeadsContext);
  const { integrationsFilter, setIntegrationsFilter } = useContext(LeadsContext);



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleLoadTags();
  }, []);



  //------------ FUNÇÃO ASSÍNCRONA HANDLE LOAD TAGS ------------//
  // Responsável por carregar as Tags do Banco de Dados via API
  // Armazena a lista de tags disponíveis no Estado "TagsDisponiveis"
  async function handleLoadTags() {
    const response = await loadTagsService();
    if (response) {
      setTagsAvailable(response.data);
    }
  };



  //------------ FUNÇÃO ASSÍNCRONA HANDLE REFRESH LEADS ------------//
  // Responsável por atualizar as leads via API
  // É utilizada a cada mudança nos hooks "currentPage", "itemsPerPage", "filterStatus" e "filterTag"
  // Armazena as leads no Estado "leads"
  // Armazena o total no Estado "total"
  async function handleRefreshLeads() {
    const offset = (currentPage - 1) * itemsPerPage;
    const term = "";
    const response = await loadLeadsService(itemsPerPage, offset, term, statusFilter, tagFilter, integrationsFilter);
    if (response) {
      setLeads(response.data.leads);
      setTotal(response.data.total);
    }
  };



  //---------- FUNÇÃO ASSÍNCRONA REMOVER TAGS EM MASSA ----------//
  const handleRemoveTagsBulk = async (tags) => {
    const response = await removeTagsBulkService(tags);
    if (response) {
      setIsOpenModalRemoveTagsBulk(false);
      handleRefreshLeads();
    }
  };



  //--------------- FUNÇÃO HANDLE ADD TAG ---------------//
  const handleAddTag = (tag) => {
    if (!tagsSelected.includes(tag)) {
      setTagsSelected([...tagsSelected, tag]);
    }
  };



  //--------------- FUNÇÃO HANDLE ADD TAG ---------------//
  const handleRemoveTag = (tag) => {
    setTagsSelected(tagsSelected.filter((t) => t !== tag));
  };



  //--------------- RETORNO DO MODAL REMOVE TAGS BULK ---------------//
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">Remover tags dos leads</h2>
          <button onClick={() => setIsOpenModalRemoveTagsBulk(false)}><X className="text-white" /></button>
        </div>

        <label className="text-sm mb-1 block">Tag(s) para remover</label>
        <input
          type="text"
          value={tagSearched}
          onChange={(e) => setTagSearched(e.target.value)}
          placeholder="Digite para buscar tags"
          className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08] w-full mb-2"
        />

        <div className="mb-2 max-h-32 overflow-y-auto">
          {tagsAvailable.filter(tag => tag.nome.toLowerCase().includes(tagSearched.toLowerCase())).map(tag => (
            <button
              key={tag.id}
              onClick={() => handleAddTag(tag.nome)}
              className="bg-surface-2 hover:bg-red-600 text-white text-xs px-2 py-1 rounded mr-2 mb-1"
            >
              {tag.nome}
            </button>
          ))}
        </div>

        <div className="flex gap-2 flex-wrap mb-4">
          {tagsSelected.map(tag => (
            <div key={tag} className="bg-red-600 px-2 py-1 rounded text-xs flex items-center gap-1">
              {tag}
              <button onClick={() => handleRemoveTag(tag)} className="text-white text-xs">×</button>
            </div>
          ))}
        </div>

        <div className="text-right">
          <button
            onClick={() => handleRemoveTagsBulk(tagsSelected)}
            className="px-4 py-2 bg-red-600 hover:bg-red-700 rounded"
          >
            Remover Tags
          </button>
        </div>
      </div>
    </div>
  );
}